import { useFieldActions } from '../../contexts/field-actions-context';
export const useUploadFile = (uploadTarget)=>{
    const { actions, formId } = useFieldActions();
    return async (filesToUpload, onDone, onError)=>{
        if (!actions?.uploadFile || !filesToUpload.length) {
            if (!actions?.uploadFile) {
                console.error('No uploadFile action');
            }
            if (!filesToUpload.length) {
                console.error('No files to upload');
            }
            return [];
        }
        const uploadTasks = filesToUpload.map(({ file })=>{
            return actions.uploadFile({
                file,
                formId,
                uploadTarget
            }).then((fileDescriptor)=>{
                const { id, displayName, url, isPrivate } = fileDescriptor;
                const uploadedFile = {
                    fileId: id,
                    displayName: displayName || file.name,
                    url: !isPrivate ? url : undefined,
                    fileType: file.type || 'application/octet-stream'
                };
                onDone({
                    file,
                    uploadedFile
                });
                return uploadedFile;
            }).catch((_e)=>{
                onError(_e, file);
            });
        });
        const uploadedValues = await Promise.all(uploadTasks);
        return uploadedValues.filter((v)=>v !== undefined);
    };
};

//# sourceMappingURL=use-upload-file.js.map